import { format } from 'date-fns';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AscendState } from '../../ducks';
import { UPDATE_TRANSACTION } from '../../ducks/actions';
import { dateFormats } from '../../ducks/util';
import { MxAccount, MxTransaction } from '../../models/mx';
import EditTransactionForm, { EditTransactionFormValues } from './EditTransactionForm';

type submitEditTransactionData = {
  account_guid: string;
  amount: number;
  date: string;
  description: string;
  guid: string;
  status: string;
  top_level_category: string;
  transaction_type: string;
};

type StateProps = { accounts: MxAccount[] };
type DispatchProps = { submitEditTransaction: (data: submitEditTransactionData) => void };
type OwnProps = { onClose: () => void; transaction: MxTransaction | undefined };
type EditTransactionDialogProps = StateProps & DispatchProps & OwnProps;

const EditTransactionDialog = ({
  accounts,
  onClose,
  submitEditTransaction,
  transaction,
}: EditTransactionDialogProps) => {
  return (
    <EditTransactionForm
      accounts={accounts}
      initialValues={transaction}
      onClose={onClose}
      onSubmit={(data: EditTransactionFormValues) =>
        submitEditTransaction({
          account_guid: data.account_guid,
          amount: data.amount,
          date:
            typeof data.date === 'string' ? data.date : format(data.date, dateFormats.yearMonthDay),
          description: data.description,
          guid: data.guid,
          status: data.status,
          top_level_category: data.top_level_category,
          transaction_type: data.type,
        })
      }
    />
  );
};

const mapStateToProps = (state: AscendState) => ({
  accounts: state.mx.accounts.data,
});

// noinspection JSUnusedGlobalSymbols
const mapDispatchToProps = (dispatch: Dispatch) => ({
  submitEditTransaction: (data: submitEditTransactionData) =>
    dispatch({ type: UPDATE_TRANSACTION, ...data }),
});

export default connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(EditTransactionDialog);
